import React from 'react';
import SVGLoader from './SVGLoader';

export default ({ width, height, viewboxWidth, viewboxHeight, ...rest }) => {
  return (
    <SVGLoader
      {...rest}
      width={width || 12}
      height={height || 12}
      viewboxWidth={viewboxWidth || 12}
      viewboxHeight={viewboxHeight || 12}
    >
      <g clipPath="url(#clip0_1_19549)">
        <path
          d="M13.4999 5H14.4999C14.4999 5 14.6666 5 14.6666 5.16667V10.8333C14.6666 10.8333 14.6666 11 14.4999 11H13.4999C13.4999 11 13.3333 11 13.3333 10.8333V5.16667C13.3333 5.16667 13.3333 5 13.4999 5Z"
          fill="currentColor"
        />
        <path
          d="M5.16667 1.33333H10.8333C10.8333 1.33333 11 1.33333 11 1.49999V2.49999C11 2.49999 11 2.66666 10.8333 2.66666H5.16667C5.16667 2.66666 5 2.66666 5 2.49999V1.49999C5 1.49999 5 1.33333 5.16667 1.33333Z"
          fill="currentColor"
        />
        <path
          d="M1.50004 5H2.50004C2.50004 5 2.66671 5 2.66671 5.16667V10.8333C2.66671 10.8333 2.66671 11 2.50004 11H1.50004C1.50004 11 1.33337 11 1.33337 10.8333V5.16667C1.33337 5.16667 1.33337 5 1.50004 5Z"
          fill="currentColor"
        />
        <path
          d="M5.16667 13.3333H10.8333C10.8333 13.3333 11 13.3333 11 13.5V14.5C11 14.5 11 14.6667 10.8333 14.6667H5.16667C5.16667 14.6667 5 14.6667 5 14.5V13.5C5 13.5 5 13.3333 5.16667 13.3333Z"
          fill="currentColor"
        />
        <path
          d="M12 2C12 2.53043 12.2107 3.03914 12.5858 3.41421C12.9609 3.78929 13.4696 4 14 4C14.5304 4 15.0391 3.78929 15.4142 3.41421C15.7893 3.03914 16 2.53043 16 2C16 1.46957 15.7893 0.960859 15.4142 0.585786C15.0391 0.210714 14.5304 0 14 0C13.4696 0 12.9609 0.210714 12.5858 0.585786C12.2107 0.960859 12 1.46957 12 2Z"
          fill="currentColor"
        />
        <path
          d="M0 2C0 2.53043 0.210714 3.03914 0.585786 3.41421C0.960859 3.78929 1.46957 4 2 4C2.53043 4 3.03914 3.78929 3.41421 3.41421C3.78929 3.03914 4 2.53043 4 2C4 1.46957 3.78929 0.960859 3.41421 0.585786C3.03914 0.210714 2.53043 0 2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2Z"
          fill="currentColor"
        />
        <path
          d="M12 14C12 14.5304 12.2107 15.0391 12.5858 15.4142C12.9609 15.7893 13.4696 16 14 16C14.5304 16 15.0391 15.7893 15.4142 15.4142C15.7893 15.0391 16 14.5304 16 14C16 13.4696 15.7893 12.9609 15.4142 12.5858C15.0391 12.2107 14.5304 12 14 12C13.4696 12 12.9609 12.2107 12.5858 12.5858C12.2107 12.9609 12 13.4696 12 14Z"
          fill="currentColor"
        />
        <path
          d="M0 14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16C2.53043 16 3.03914 15.7893 3.41421 15.4142C3.78929 15.0391 4 14.5304 4 14C4 13.4696 3.78929 12.9609 3.41421 12.5858C3.03914 12.2107 2.53043 12 2 12C1.46957 12 0.960859 12.2107 0.585786 12.5858C0.210714 12.9609 0 13.4696 0 14Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_19549">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </SVGLoader>
  );
};
